import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Tabs as MaterialTabs, Tab } from '@mui/material';

import { tabsType } from 'common/typings';
import { colors } from 'utils/constants';

const StyledTabs = styled(MaterialTabs)`
  color: ${colors.tableHeaderGray};

  .MuiTab-root:not(.Mui-disabled):hover {
    opacity: 1;
  }
`;

/**
 * The project-standard controlled wrapper around MUI `Tabs`: renders a tab
 * strip from a `{ label, value, disabled }` array with the app's secondary
 * indicator color. Use for tab navigation instead of raw MUI `Tabs`.
 */
const Tabs = ({ className, handleSetTab, tabIndex, tabs }) => (
  <StyledTabs
    className={className}
    onChange={(_, newValue) => handleSetTab(newValue)}
    slotProps={{
      indicator: {
        style: {
          backgroundColor: colors.secondary,
        },
      },
    }}
    textColor="inherit"
    value={tabIndex}
  >
    {tabs.map(tab => (
      <Tab disabled={tab.disabled} label={tab.label} key={tab.value} value={tab.value} />
    ))}
  </StyledTabs>
);

Tabs.defaultProps = {
  className: '',
};

Tabs.propTypes = {
  className: PropTypes.string,
  handleSetTab: PropTypes.func.isRequired,
  /** Value of the selected tab; MUI also accepts `false` to render no tab selected. */
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  tabs: tabsType.isRequired,
};

export default Tabs;
